(function (root, factory) {
  const createPageTrackingPageJump = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = createPageTrackingPageJump;
    return;
  }

  if (root) {
    root.createPageTrackingPageJump = createPageTrackingPageJump;
  }
})(typeof window !== 'undefined' ? window : undefined, function createPageTrackingPageJumpFactory() {
  return function createPageTrackingPageJump(core, options) {
    const currentOptions = options || {};
    const pageIdentity = currentOptions.pageIdentity || {
      pageName: '',
      subPageName: '',
      pageId: ''
    };
    const pageEnterAtMs = Number(currentOptions.pageEnterAtMs) || Date.now();

    function savePendingPageJump() {
      const currentUrl = core.window.location && core.window.location.href ? core.window.location.href : '';

      core.writeSessionStorage(
        core.pendingPageJumpKey,
        JSON.stringify(
          core.utils.buildPendingPageJumpState({
            pageId: pageIdentity.pageId,
            pageName: pageIdentity.pageName,
            subPageName: pageIdentity.subPageName,
            pageUrl: currentUrl,
            enterAt: pageEnterAtMs,
            leaveAt: Date.now()
          })
        )
      );
    }

    function readPendingPageJump() {
      let rawValue;
      let parsedValue;

      rawValue = core.readSessionStorage(core.pendingPageJumpKey);

      if (!rawValue) {
        return null;
      }

      try {
        parsedValue = JSON.parse(rawValue);
      } catch (error) {
        core.writeSessionStorage(core.pendingPageJumpKey, '');
        return null;
      }

      return parsedValue;
    }

    function trackPendingPageJump() {
      let now;
      let pendingPageJump;
      let durationSeconds;
      let dataInfo;
      let currentUrl;

      if (!core.canTrack()) {
        return false;
      }

      pendingPageJump = readPendingPageJump();
      currentUrl = core.window.location && core.window.location.href ? core.window.location.href : '';

      if (
        !core.utils.shouldReportPendingPageJump({
          pendingPageJump: pendingPageJump,
          currentUrl: currentUrl,
          nowMs: Date.now(),
          maxAgeMs: core.pendingPageJumpMaxAgeMs,
          currentOrigin: core.window.location && core.window.location.origin ? core.window.location.origin : ''
        })
      ) {
        core.writeSessionStorage(core.pendingPageJumpKey, '');
        return false;
      }

      core.writeSessionStorage(core.pendingPageJumpKey, '');
      now = new Date();
      durationSeconds = Math.max(
        0,
        Math.round((Number(pendingPageJump.leaveAt) - Number(pendingPageJump.enterAt)) / 1000)
      );

      dataInfo = core.buildDataInfo({
        type: core.config.eventTypes && core.config.eventTypes.pageJump,
        prePageName: pendingPageJump.prePageName,
        preSubPageName: pendingPageJump.preSubPageName,
        toPageName: pageIdentity.pageName,
        toSubPageName: pageIdentity.subPageName,
        duration: durationSeconds
      }, now);
      return core.sendTrackingEvent({
        basicInfo: core.buildBasicInfo(),
        dataInfo: dataInfo
      }, true);
    }

    return {
      savePendingPageJump,
      readPendingPageJump,
      trackPendingPageJump
    };
  };
});
